import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import * as moment from 'moment';
import MediaQuery from 'react-responsive';





export default class SingleMiladiDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arivaldate: null,
            arivalfocused: null,
        }

        moment.locale('en')

    }

    render() {
        let newdate = new Date();
        let today = moment(newdate).format("YYYY-MM-DD");
        // if (this.state.arivaldate != null) {
        //     () => {
        //         let date = moment(this.state.arivaldate).format("YYYY-MM-DD")
        //         this.props.getdate(date)
        //     }
        // }

        return (
            <div className="Main-date-div">

                <MediaQuery query="(min-width: 769px)">
                    <div className='other-display'>
                        <SingleDatePicker
                            date={this.state.arivaldate} // momentPropTypes.momentObj or null
                            onDateChange={date => {
                                this.setState({ arivaldate: date });
                                this.props.set(moment(date).format("YYYY-MM-DD"))
                            }
                            } // PropTypes.func.isRequired
                            focused={this.state.arivalfocused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ arivalfocused: focused })} // PropTypes.func.isRequired
                            id="arrivaldate" // PropTypes.string.isRequired,
                            displayFormat='YYYY-MM-DD'
                            placeholder='Arrival Date'
                            hideKeyboardShortcutsPanel={true}
                        // keepOpenOnDateSelect={true}
                        />


                        {this.state.arivalfocused != null && this.state.arivalfocused === true &&
                            <div className='Today-date-change'>
                                <span className='date-of-today'>
                                    Today : <span>{today}</span>
                                </span>
                            </div>
                        }
                    </div>
                </MediaQuery>

                <MediaQuery query="(max-width: 768px)">
                    <div className='mobile-display'>
                        <SingleDatePicker
                            date={this.state.arivaldate} // momentPropTypes.momentObj or null
                            onDateChange={date => {
                                this.setState({ arivaldate: date });
                                this.props.set(moment(date).format("YYYY-MM-DD"))
                            }
                            } // PropTypes.func.isRequired
                            focused={this.state.arivalfocused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ arivalfocused: focused })} // PropTypes.func.isRequired
                            id="arrivaldate" // PropTypes.string.isRequired,
                            displayFormat='YYYY-MM-DD'
                            placeholder='Arrival Date'
                            hideKeyboardShortcutsPanel={true}
                            orientation={'vertical'}
                        // keepOpenOnDateSelect={true}
                        />


                        {this.state.arivalfocused != null && this.state.arivalfocused === true &&
                            <div className='Today-date-change'>
                                <span className='date-of-today'>
                                    Today : <span>{today}</span>
                                </span>
                            </div>
                        }
                    </div>
                </MediaQuery>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Calendar/SingleMiladiDate.jsx